import { styled } from "@mui/material/styles";

// Images
import SignUpImage from "~/assets/images/SignupImage.png";

const styledName = "Registration";

export const StyledSignUpBackground = styled("div", { name: styledName })({
  "&": {
    position: "relative",
    backgroundImage: `url(${SignUpImage})`,
    width: "100vw",
    height: "100vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
});

export const StyledFormPosition = styled("div", { name: styledName })({
  "&": {
    position: "absolute",
    height: "fit-content",
    width: "fit-content",
    top: "50%",
    right: "25%",
    transform: `translate(25%,-50%)`,
  },
});
